const e = "app_refresh_id", p = "Idempotence-Key";
export {
  e as APP_REFRESH_ID,
  p as IDEMPOTENCE_KEY_HEADER_NAME
};
//# sourceMappingURL=constants.js.map
